
import Vue from 'vue'
import { Component } from 'vue-property-decorator';
@Component
export default class HeaderNotice extends Vue{
    badgeProps = {
        offset: [20, 0]
    }
}
